import React from 'react';
import './style.scss';
import { lockIcon } from '../icons/lockIcon';

const PcItem = ({ pc }) => {
    const blocked = pc.state === 2;
    const session = pc.activeSession || null;

    let stateClass = 'pcItem--free';
    let displayTime = null;

    if (blocked) {
        stateClass = 'pcItem--blocked';
    } else if (session) {
        const remainingSeconds = session.remainingMinutes;

        if (!remainingSeconds) {
            // активная сессия без остатка времени (безлимит/постоплата или баланс на нуле)
            stateClass = 'pcItem--nolimit';
            displayTime = '∞';
        } else {
            const remainingMinutes = Math.floor(remainingSeconds / 60);
            const hours = Math.floor(remainingMinutes / 60);
            const minutes = remainingMinutes % 60;

            displayTime = remainingMinutes < 1 ? '< 1 мин' : `${hours}ч ${minutes}мин`;

            stateClass = remainingMinutes <= 30 ? 'pcItem--warning' : 'pcItem--busy';
        }
    }

    return (
        <div className={`pcItem ${stateClass}`}>
            <p>{pc.number}</p>

            {session && !blocked && (
                <p className="timeLeft">
                    {displayTime ? displayTime : '∞'}
                </p>
            )}

            {blocked && <div>{lockIcon}</div>}
        </div>
    );
};

export default PcItem;
